import React from 'react';
import { bool, string, arrayOf } from 'prop-types';
import { Card } from '@thd-olt-component-react/card';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Promo } from './Promo/Promo';
import { EmailForm } from './EmailForm/EmailForm';
import { HdhomeCatalogPromoPlaceholder } from './HdhomeCatalogPromoPlaceholder';
import './hdhome-catalog-promo.scss';

const HdhomeCatalogPromoComponent = ({ campaignId, formSubmission, subscriptionType }) => {

  const secondPromoProps = {
    title: 'Enjoy 10% off',
  };

  if (formSubmission) {
    secondPromoProps.emailComponent = (
      <QueryProvider cacheKey="email-form">
        <EmailForm campaignId={campaignId} subscriptionType={subscriptionType} />
      </QueryProvider>
    );
  } else {
    secondPromoProps.link = 'http://pages.homedepot.com/styleanddecor';
    secondPromoProps.linkText = 'Sign Up';
    secondPromoProps.emailComponent = null;
  }

  const promo = (
    <Promo
      title={secondPromoProps.title}
      link={secondPromoProps.link}
      linkText={secondPromoProps.linkText}
      emailComponent={secondPromoProps.emailComponent}
    >
      <p className="hdhome-catalog-promo__item-p">
        <span className="hdhome-catalog-promo__item-span">
          Sign up for Style & Decor emails and save on your next order.
        </span>
        <span className="hdhome-catalog-promo__item-span"> Valid on select items.</span>
      </p>
    </Promo>
  );
  return (
    <div className="hdhome-catalog-promo">
      <Card>
        {promo}
        <Card.Content maxHeight="none">
          {promo}
        </Card.Content>
      </Card>
    </div>
  );
};

const propTypes = {
  campaignId: string,
  formSubmission: bool,
  subscriptionType: arrayOf(string)
};

const defaultProps = {
  campaignId: null,
  formSubmission: false,
  subscriptionType: []
};

HdhomeCatalogPromoComponent.propTypes = propTypes;
HdhomeCatalogPromoComponent.defaultProps = defaultProps;

const HydratedComponent = withHydrator({
  delay: 2000,
  id: 'hdhome-catalog-hydrator',
  placeholder: (
    <HdhomeCatalogPromoPlaceholder
      color="#E0E0E0"
      showLoadingAnimation
    />
  ),
  scrollBuffer: 750,
}, HdhomeCatalogPromoComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);
const HdhomeCatalogPromo = withLayoutGroup({
  name: 'email-promo'
}, DynamicComponent);

HdhomeCatalogPromo.propTypes = propTypes;
HdhomeCatalogPromo.defaultProps = defaultProps;

export { HdhomeCatalogPromo };
